import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isPlanSetupCompleted, checkAndClearSetupCompletion } from 'utlis/setupUtils';

/**
 * Higher-Order Component to protect setup routes from being accessed
 * after plan setup has been completed
 */
const withSetupRouteProtection = (WrappedComponent, setupRoutePatterns = []) => {
  return function SetupRouteProtection(props) {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      // Check if current route matches any of the protected setup patterns
      const isSetupRoute = setupRoutePatterns.some(pattern => 
        location.pathname.includes(pattern)
      );
      
      if (isSetupRoute) {
        // Check if a new setup is being started and clear completion flag if needed
        checkAndClearSetupCompletion();
        
        // If setup is completed, redirect
        if (isPlanSetupCompleted()) {
          console.log("Plan setup already completed. Redirecting to dashboard.");
          navigate("/v1/", { replace: true });
          return;
        }
      }
    }, [navigate, location.pathname]);

    // Check again before rendering (in case localStorage was modified)
    const isSetupRoute = setupRoutePatterns.some(pattern => 
      location.pathname.includes(pattern)
    );
    
    if (isSetupRoute && isPlanSetupCompleted()) {
      // Don't render the component, redirect will happen in useEffect
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withSetupRouteProtection;
